module.exports = __webpack_public_path__ + "static/media/free_tools_1.2920044a.png";